export class ActionItemConstants {
    public static readonly ActionItem_Error_Heading = 'Please correct the following errors to create the Action Item.';
    public static readonly ActionItem_Title_Required = 'Title is required.';
    public static readonly ActionItem_Type_Required= 'Type is required';
    public static readonly ActionItem_Assignees_Required = 'Assignees is required';
    public static readonly ActionItem_Verifier_Required = 'Verifier is required';
    public static readonly ActionItem_DueDate_Required = 'Due Date is required';

    public static readonly ActionItem_Attachments_FolderName = 'eqmsactionitemattachments';

    public static readonly ActionItem_Same_AssigneeNVerifier = 'A same user cannot be both Assigned User and Verifier for a given Action Item.';

    public static readonly ActionItem_AddActionItems_Failure = 'Failed to create action items!';
    public static readonly ActionItem_UpdateActionItems_Failure = 'Failed to update action items!';
    public static readonly ActionItem_AddActionItems_Success = 'Action Items created successfully!';
    public static readonly ActionItem_UpdateActionItems_Success = 'Action Items updated successfully!';
    public static readonly ActionItem_Creation_TechnicalError = "Due to some technical issue, the action items were not created. Please try again."

    public static readonly ActionItem_TooltipForRiskAssessmentRequired = 'If True, please follow the local applicable Risk Assessment procedure.';
    public static readonly ActionItem_TooltipForVerificationRequired = 'If True, a Verifier must be selected to complete an additional verification step in order to complete the Action Item.';

    public static readonly Severity_Info:string = "info";
    public static readonly Severity_Err: string = 'error';
    public static readonly ActionItem_Update_Complete:string = "Action Item Update Completed Successfully";
    public static readonly ActionItem_Update_StatusUpdate = 'Status Update';
    public static readonly ActionItem_Edit_ActionItemUpdate = 'Action Item Update';  
    public static readonly ReasonValidationMessage : string =' is required';

    // Speed Dial button tooltip + Modal text for Action Item Life Cycle
    public static readonly ActionItem_SpeedDialButton_Complete = 'Complete';
    public static readonly ActionItem_SpeedDialButton_DefferedLabel = 'Deferred';
    public static readonly ActionItem_SpeedDialButton_Defer = 'Defer';
    public static readonly ActionItem_SpeedDialButton_VoidedLabel = 'Voided';
    public static readonly ActionItem_SpeedDialButton_Void = 'Void';
    public static readonly ActionItem_SpeedDialButton_Verify = 'Verify';
    public static readonly ActionItem_SpeedDialButton_Reject = 'Reject';
    public static readonly ActionItem_SpeedDialButton_Edit = 'Edit';
    public static readonly ActionItem_SpeedDialButton_EditForAssignee = 'EditForAssignee';

    // Modal Title for Action Item Life Cycle
    public static readonly ActionItem_CompleteModal_Title = 'Complete Action Item';
    public static readonly ActionItem_DeferModal_Title = 'Defer Action Item';
    public static readonly ActionItem_VoidModal_Title = 'Void Action Item';
    public static readonly ActionItem_VerifyModal_Title = 'Verify Action Item';
    public static readonly ActionItem_RejectModal_Title = 'Reject Action Item';
    
    // Esign(s) for Action Item Life Cycle
    public static readonly ActionItem_CompleteModal_ESign = 'I hereby declare that I have completed this action item accurately as per the applicable procedure.';
    public static readonly ActionItem_DeferModal_ESign = 'I hereby declare that this action item can be deferred as per the applicable procedure.';
    public static readonly ActionItem_VoidModal_ESign = 'I hereby declare that this action item can be voided as per the applicable procedure.';
    public static readonly ActionItem_VerifyModal_ESign = 'I hereby declare that I have verified this action item accurately as per the applicable procedure';
    public static readonly ActionItem_RejectModal_ESign = 'You must enter the reason for rejection.';
    
    // Modal Input label for Action Item Life Cycle
    public static readonly ActionItem_CompleteModal_InputLabel = 'Action Taken';
    public static readonly ActionItem_DeferModal_InputLabel = 'Deferral Reason';
    public static readonly ActionItem_VoidModal_InputLabel = 'Void Reason';
    public static readonly ActionItem_RejectModal_InputLabel = 'Rejection Reason';
    public static readonly ActionItem_VerifierNotesModal_InputLabel = 'Verifier Notes';

    public static readonly ActionItemClose_ConfirmationMessage: string = 'Any unsaved change will be lost when closing the screen. Do you want to continue?';
    public static readonly Confirmation_Header: string = 'Confirmation';
    public static readonly File_Upload_Failed : string = 'A Technical error occurred and the Name was not uploaded. Please contact technical support.'
    public static readonly ActionItemAttachments : string = 'Action Item Attachment(s)'

    //File Size Limit
    public static readonly Attachment_File_Max_Size:number=100;
    
}
